import { State } from './reducer'

export const selectIsLoading = (state: State) => state.isLoading
export const selectHasFetched = (state: State) => state.hasFetched
export const selectIdentifiers = (state: State) => state.identifiers
export const selectData = (state: State) => state.data
export const selectLastError = (state: State) => state.lastError
